import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});


$(function () {
  // ハンバーガーメニューを開く処理
  $('.btn-trigger').on('click', function() {
    $(this).toggleClass('is_active');
    $('.nav').toggleClass('is_active');
    
    // テキストの切り替え処理
    let text = $(this).find('p').text();
    if (text === 'OPEN') {
      $(this).find('p').text('CLOSE');
    } else {
      $(this).find('p').text('OPEN');
    }
    
    return false;
  });
});

$(function() {
  const newSwiper = new Swiper('.index_swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    spaceBetween: 60,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      1000: {
        slidesPerView: 2.5,// PCでは3枚を中央に、.5で見切れ具合を調整
      },
      768: {
        slidesPerView: 1,// PCでは3枚を中央に、.5で見切れ具合を調整
      }
    },
  
    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });
});


$(function () {
  const mySwiper = new Swiper('.archive-swiper', {
    // Optional parameters
    effect: 'fade', // フェードのエフェクト
    autoplay: { // 自動再生
      delay: 3000, // 1.5秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
    loop: true,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 1,
        speed: 1200,
      },
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: "fraction", // ページネーションのtypeを指定
      formatFractionCurrent: function (number) {
        return '0' + number;
      },
      formatFractionTotal: function (number) {
        return ('0' + number).slice(-2); // 先頭に0をつける、二桁表示
      }
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  $('.small_slide').click(function() {
    // サムネイル画像を1枚クリックしたら何枚目を取得しているのかを出力
    const index = $('.small_slide').index($(this));
    slideThumb(index);
  });

  const swiper2 = new Swiper(".archive-slider", {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  // サムネイルをアーカイブ画像から取得する（連動させる）関数を定義
  function slideThumb(index) {
    swiper2.slideTo(index);
  }
});



// タブ切り替え動作指示
$(function() {
  $('.faq_list li').on('click', function() {
    // タブのアクティブ状態をリセット
    $('.faq_list li').removeClass('is_active');
    $(this).addClass('is_active');

    // クリックされたタブのインデックスを取得
    var index = $('.faq_list li').index(this);

    // コンテンツのアクティブ状態をリセットして、フェードアウト
    $('.faq_content.is_active').fadeOut(300, function() {
      $(this).removeClass('is_active');

      // 対応するコンテンツをフェードイン
      $('.faq_content').eq(index).fadeIn(300).addClass('is_active');
    });
  });
});

/*------------ タブをクリックしたときの処理 ------------*/
jQuery(document).ready(function($) {
  $('.faq_list li').on('click', function() {
    // クリックされたタブのdata-target属性を取得
    var target = $(this).data('target');
    
    // 該当のコンテンツを取得
    var targetContent = $('#' + target);

    // タブのクラスを即座に変更
    $('.faq_list li').removeClass('select');
    $(this).addClass('select');
    
    // コンテンツのクラスを即座に変更
    $('.faq_content').removeClass('is_active');
    targetContent.addClass('is_active');

    // スムーススクロールを実行
    if (targetContent.length) {
      var offset = targetContent.offset().top - 50; // オフセット調整
      $('html, body').animate({
        scrollTop: offset
      }, 600); // スクロール時間
    }
  });
});



 /*------------ パララックス背景 ------------*/
  // GSAPとScrollTriggerを登録
  document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);
  
    // デバイスの幅に応じて異なる値を設定する関数
    function getParallaxYValue() {
      if (window.matchMedia("(max-width: 768px)").matches) {
        return -50; // スマホ用のY値
      } else {
        return -70; // パソコン用のY値
      }
    }
  
    // 各要素に対してパララックスアニメーションを設定
    function createParallaxAnimations() {
      gsap.utils.toArray('.js-parallax').forEach(wrap => {
        const y = getParallaxYValue(); // デバイスに応じたY値を取得
  
        ScrollTrigger.create({
          trigger: wrap,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 5,
          onUpdate: self => {
            gsap.to(wrap, { y: y * self.progress });
          }
        });
      });
    }
  
    createParallaxAnimations();
  
    // ウィンドウサイズ変更時にアニメーションを更新
    window.addEventListener('resize', () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill()); // 既存のScrollTriggerを削除
      createParallaxAnimations(); // 再作成
    });
  });



// お問い合わせページのみで発令
if(document.URL.match(/contact/)){
  const topValidationInterface = topValidation('zip', 'address01', 'address02', 'address03'); // 一つ目の住所入力欄
  topValidationInterface.autoFillAddress('zip2', 'address04', 'address05', 'address06');      // 二つ目の住所入力欄

  /*------------ お問い合わせ表示切替 ------------*/
  jQuery(document).ready(function($) {
    function updateOpenSection() {
      var selectedValue = $('input[name="radio"]:checked').val();
      
      // 売却のご相談または査定のご依頼が選択されたかチェック
      if (selectedValue === "売却のご相談" || selectedValue === "査定のご依頼") {
        // .open要素を表示し、必須フィールドを有効化
        $('.open').show();
        $('.open_need').each(function() {
          $(this).addClass('check_required');
          $(this).prop('required', true);
        });
      } else {
        // .open要素を非表示にし、必須フィールドを無効化
        $('.open').hide();
        $('.open_need').each(function() {
          $(this).removeClass('check_required');
          $(this).removeAttr('required');  // propからremoveAttrに変更
        });
      }
      // バリデーションをリフレッシュ
      topValidationInterface.refresh();
    }

    /*------------ 入力画面時の読み込み------------*/
    if($('.mw_wp_form_input').length > 0) {
      $(document).ready( function(){
        updateOpenSection();
      });

      // ラジオボタンが変更されたときに状態を更新
      $('input[name="radio"]').change(function() {
        updateOpenSection();
      });
    }


    /*------------ お問い合わせ確認画面での表示切替 ------------*/
    if ($('.contact_confirm').length > 0) {
      var selectedValue = $('input[name="radio"]').val();
      console.log(selectedValue);
      if (selectedValue === "売却のご相談" || selectedValue === "査定のご依頼") {

        $('.open').show();
      } else {
        $('.open').hide();
      }
    }

    /*------------ 戻るボタンを押した場合の表示切替 ------------*/
    function handleBackButton() {
      // フォームに戻った際に再度状態を更新
      updateOpenSection();
    }

    /*--- 入力画面ページの場合---*/
    if ($('.mw_wp_form_input').length > 0) {
      // ページが読み込まれたときに初期状態を更新
      updateOpenSection();

      // 戻るボタンがクリックされたときに状態を更新
      $('input[value="back"]').on('click', function() {
        handleBackButton();
      });
    }
  });
}